import React from 'react';
import { Box, Typography } from '@mui/material';
import TreatmentHistoryList from '../../components/TreatmentHistory';

const TreatmentHistory = ({ patientId }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Treatment History
      </Typography>
      <TreatmentHistoryList patientId={patientId} />
    </Box>
  );
};

export default TreatmentHistory; 